import { specialFont, mainFont } from "../../../Infrastructure/Theme/fontFamily";

export const styles = {
  heroSection: {
    background: "linear-gradient(135deg, #000080 0%, #0000FF 130%)",
    pt: { xs: 9, md: 13 },
    pb: { xs: 9, md: 13 },
  },
  heroEyebrow: {
    fontFamily: mainFont,
    fontWeight: 700,
    fontSize: { xs: "12px", md: "14px" },
    letterSpacing: "2px",
    textTransform: "uppercase",
    color: "rgba(255, 255, 255, 0.75)",
    textAlign: "center",
  },
  heroHeadline: {
    fontFamily: specialFont,
    fontSize: { xs: "28px", sm: "36px", md: "44px" },
    lineHeight: 1.3,
    color: "#fff",
    textAlign: "center",
    mt: 2,
  },
  heroSubtext: {
    fontFamily: mainFont,
    fontSize: { xs: "16px", md: "20px" },
    lineHeight: 1.6,
    color: "rgba(255, 255, 255, 0.85)",
    textAlign: "center",
    maxWidth: "620px",
    mx: "auto",
    mt: 3,
  },

  storySection: {
    pt: { xs: 7, md: 10 },
    pb: { xs: 7, md: 10 },
  },
  storyTitle: {
    fontFamily: specialFont,
    fontSize: { xs: "24px", md: "32px" },
    color: "primary.main",
    textAlign: "center",
    lineHeight: 1.3,
  },
  storyParagraph: {
    fontFamily: mainFont,
    fontSize: { xs: "16px", md: "18px" },
    color: "#555",
    lineHeight: 1.7,
    maxWidth: "720px",
    mx: "auto",
    mt: 4,
  },

  valuesSection: {
    pt: { xs: 7, md: 10 },
    pb: { xs: 7, md: 10 },
    backgroundColor: "#f5f7fa",
  },
  valuesTitle: {
    fontFamily: specialFont,
    fontSize: { xs: "24px", md: "32px" },
    color: "primary.main",
    textAlign: "center",
    lineHeight: 1.3,
  },
  valueCard: {
    height: "100%",
    backgroundColor: "#fff",
    border: "1px solid #eee",
    borderRadius: "20px",
    p: { xs: 3, md: 4 },
  },
  valueIconCircle: {
    width: "48px",
    height: "48px",
    borderRadius: "50%",
    backgroundColor: "primary.main",
    color: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    mb: 2,
  },
  valueTitle: {
    fontFamily: mainFont,
    fontWeight: 700,
    fontSize: "20px",
    color: "primary.main",
    mb: 1,
  },
  valueDescription: {
    fontFamily: mainFont,
    fontSize: "15px",
    color: "#555",
    lineHeight: 1.7,
  },
};
